import type { IKsyosProfileDetails } from './addKsyosEmployeeState';
import { ProfileDetails } from './ProfileDetails';
import { Roles } from './Roles';

interface IProfileProps {
    onUpdateIsValid: (isValid: boolean) => void;
    onUpdateManagerRoleId: (id?: string) => void;
    onUpdateProfileDetails: (profileDetails: IKsyosProfileDetails) => void;
    profileDetails?: IKsyosProfileDetails;
}

export function Profile(props: IProfileProps) {
    return (
        <>
            <ProfileDetails {...props} />
            <Roles {...props} />
        </>
    );
}
